import { IncentiveCategory } from '@varo/graphql-schema-types';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { getIncentiveCopyPrefix } from 'features/incentive/helpers/getIncentiveCopyPrefix';
import {
  getIncentiveButtonAnalytics,
  IncentiveScreenNames,
} from 'features/incentive/helpers/incentiveAnalytics';
import { useIncentiveScreenViewed } from 'features/incentive/hooks/useIncentiveAnalytics';
import useIncentiveProgram from 'features/incentive/hooks/useIncentiveProgram';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { VaroPressableNames } from 'shared/analytics/types/pressableNames';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';

interface IncentiveOptedInScreenProps {
  incentiveType: IncentiveCategory;
}

function IncentiveOptedInScreen({
  incentiveType,
}: IncentiveOptedInScreenProps) {
  const { programId } = useLocalSearchParams<{ programId: string }>();
  const router = useRouter();
  const { t: translatedText } = useTranslation('incentive', {
    keyPrefix: getIncentiveCopyPrefix(incentiveType, 'optedIn'),
  });
  const { content } = useIncentiveProgram(incentiveType, programId);
  const maxPrize = content?.content.max_prize_display;

  useIncentiveScreenViewed({
    screenName: IncentiveScreenNames.OPTED_IN,
    incentiveType,
  });

  const handleContinuePress = () => {
    router.dismissTo({
      pathname: '/incentive/[programId]',
      params: { programId },
    });
  };

  return (
    <SuccessScreen
      visual="CARD_D"
      titleText={translatedText('title')}
      content={
        <BodyBaseText numberOfLines={0} style={styles.bodyText}>
          {maxPrize
            ? translatedText('body', { maxPrize })
            : translatedText('bodyWithoutPrize')}
        </BodyBaseText>
      }
      primaryButton={{
        label: translatedText('continue'),
        onPress: handleContinuePress,
        componentAnalytics: getIncentiveButtonAnalytics(
          incentiveType,
          VaroPressableNames.INCENTIVE.INCENTIVE_OPTED_IN_CONTINUE,
        ),
      }}
    />
  );
}

const styles = StyleSheet.create({
  bodyText: {
    textAlign: 'center',
  },
});

export default IncentiveOptedInScreen;
